"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const bookmarkfilled = _ref => {
  let {
    title,
    description,
    ...props
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("svg", _extends({}, props, {
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": (title ? `title-bookmarkfilled` : '') + (description ? ` desc-bookmarkfilled` : '') || undefined,
    role: "img"
  }), title && /*#__PURE__*/_react.default.createElement("title", {
    id: "title-bookmarkfilled"
  }, title), description && /*#__PURE__*/_react.default.createElement("desc", {
    id: "desc-bookmarkfilled"
  }, description), /*#__PURE__*/_react.default.createElement("path", {
    d: "M20.75 0H2.75C2.33579 0 2 0.335786 2 0.75V22.75L2.00666 22.8529C2.08118 23.4202 2.76474 23.7095 3.22683 23.3289L11.75 16.307L20.2732 23.3289C20.7624 23.7319 21.5 23.3839 21.5 22.75V0.75C21.5 0.335786 21.1642 0 20.75 0Z",
    fill: "inherit"
  }));
};
var _default = exports.default = bookmarkfilled;